import { useLocalStorageChange } from './useLocalStorageChange';

export const useSupplierSelection = () => {
  return useLocalStorageChange<boolean>('isSupplierSelection');
};